export const SelectedOfferOverlayStyles = {
    overlayTitle: 'absolute z-10 bg-selectedOptionBlue100 -top-3.5 -right-2 text-white py-0.5 px-4 rounded',
    overlaySelected: 'absolute w-full h-full border-solid border-4 border-blue450 rounded bg-opacity-0 z-0',
}